import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { ServiceDefinition } from '../../models';
import { ServiceCategory } from '../../models';
import { List } from 'immutable';

export interface IServiceCategorySelectEvent {
  categoryIndex: number,
  serviceCategory: ServiceCategory
}

export interface IServiceDefinitionSelectEvent {
  categoryIndex: number,
  serviceDefinitionIndex: number,
  serviceDefinition: ServiceDefinition
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'smr-service-definition-list',
  templateUrl: 'service-definition-list.component.html'
})

export class ServiceDefinitionListComponent {

  @Input() serviceCategories: List<ServiceCategory>;

  @Output() serviceDefinitionSelect = new EventEmitter<IServiceDefinitionSelectEvent>();

  @Output() serviceCategorySelect = new EventEmitter<IServiceCategorySelectEvent>();

  constructor () {
  }

  public onServiceCategorySelect (serviceCategoryIndex: number, serviceCategory: ServiceCategory, $event) {
    this.serviceCategorySelect.emit({
      categoryIndex: serviceCategoryIndex,
      serviceCategory: serviceCategory
    });
    $event.stopPropagation();
  }

  public onServiceDefinitionSelect (categoryIndex: number, serviceDefinitionIndex: number, serviceDefinition: ServiceDefinition, $event) {
    this.serviceDefinitionSelect.emit({
      categoryIndex: categoryIndex,
      serviceDefinitionIndex: serviceDefinitionIndex,
      serviceDefinition: serviceDefinition
    });

    $event.stopPropagation();
  }

}
